import { siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[720px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="absolute top-0 right-0 w-full md:w-[55%] h-full opacity-30 md:opacity-90">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-background-50/50 to-background-50 md:to-transparent z-10"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20manga%20reading%20scene%20with%20floating%20comic%20panels%20and%20colorful%20speech%20bubbles%2C%20warm%20orange%20and%20coral%20tones%2C%20modern%20digital%20illustration%20style%2C%20dynamic%20composition%20with%20manga%20character%20silhouettes%2C%20clean%20aesthetic%20background%20with%20subtle%20paper%20texture%2C%20energetic%20youthful%20atmosphere%2C%20editorial%20quality%20artwork%2C%20soft%20gradient%20lighting%2C%20no%20text%20visible%20in%20panels%2C%20harmonious%20warm%20color%20palette%2C%20Asian%20comic%20art%20influence&width=900&height=720&seq=hero-manga-main&orientation=landscape"
          alt="古古漫画网 - 热门漫画每日更新，追更连载免费全集下拉式阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-20 w-full px-4 md:px-6 max-w-screen-2xl mx-auto">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 text-xs font-medium px-3 py-1.5 rounded-full mb-5">
            <i className="ri-fire-line text-sm"></i>
            <span>{siteInfo.tagline}</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-3">
            古古漫画网
            <span className="block text-xl md:text-2xl lg:text-3xl text-primary-500 mt-2 font-sans font-medium">
              追更连载 · 每日更新 · 免费全集
            </span>
          </h1>

          <p className="text-lg md:text-xl text-foreground-800 font-heading mb-5 leading-snug">
            国漫日漫韩漫人气漫画一网打尽，你的专属漫画追更世界
          </p>

          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
            古古漫画网是专业的在线漫画阅读平台，汇集海量国漫、日漫、韩漫热门作品。我们坚持每日更新追更连载，提供免费全集下拉式阅读体验，让每一位漫迷都能畅享人气漫画的精彩世界。无论你是热血少年、恋爱甜宠还是悬疑推理的爱好者，古古漫画网都能满足你的阅读需求。
          </p>

          <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-8">
            {siteInfo.stats.map((stat) => (
              <div key={stat.label} className="flex items-baseline gap-1.5">
                <span className="text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</span>
                <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-flashlight-line"></i>
              立即追更
            </a>
            <a
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 bg-secondary-100 hover:bg-secondary-200 text-foreground-800 font-medium text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line"></i>
              人气排行
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}